import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  Input,
  Row,
  Form,
  Col,
  InputNumber,
  notification,
  DatePicker,
  Button,
  Select,
  Checkbox,
  Tooltip,
} from "antd";
import moment from "moment";
import { PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import CurrencyInput from "react-currency-input";
const layout = {
  labelCol: {
    span: 10,
  },
  wrapperCol: {
    span: 11,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const TenantAccountUpdateForm = (props) => {
  const { t } = useTranslation();
  const { Option } = Select;
  const [activeTypeId, setActiveTypeId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [IsChequePaymentAccount, setIsChequePaymentAccount] = useState(false);
  const [form] = Form.useForm();
  const [hasErp, setHasErp] = useState(false);

  useEffect(() => {
    props.data.dueDate =
      props.data.dueDate !== null ? moment(props.data.dueDate) : null;
    setLoading(false);

    if (props.data) {
      props.data.typeValue =
        props.data.typeValue == null
          ? undefined
          : props.data.typeValue.toString();
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    RequestHandler.get("/TenantErpProgram/GetByTenant").then((response) => {
      if (response) {

        setHasErp(true);
        RequestHandler.get(`/FirmClass`).then((responseFirmClass) => {

          if (response.erpProgramId == 2 && responseFirmClass.value.find(i => i.erpValue == "7"))
            setIsChequePaymentAccount(true)
        });
      }
    });
  }, []);

  const onFinishUpdate = (values) => {
    RequestHandler.put(
      `/TenantAccount`,
      {
        Id: values.id,
        Name: values.name,
        IsCalculated: values.isCalculated,
        Type: parseInt(values.typeValue),
        ErpCode: values.erpCode,
        ErpAccountingCode: values.erpAccountingCode,
        ErpBankCode: values.erpBankCode,
        DueDate: values.dueDate,
        InterestRate: values.interestRate,
        creditLimit: values.creditLimit,
        chequeInPaymentAccount: values.chequeInPaymentAccount,
        chequeOutPaymentAccount: values.chequeOutPaymentAccount,
        excludeFromErpTransfer: values.excludeFromErpTransfer
      },
      false,
      { rawResponse: true }
    )
      .then((res) => {
        if (res.status == 200) {
          openNotificationWithIconUpdate("success");
          setTimeout(
            function () {
              props.sendDataForUpdate("success");
              setLoading(false);
            }.bind(this),
            2000
          );
        } else {
          setLoading(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const openNotificationWithIconUpdate = (type) => {
    notification[type]({
      message: t("success"),
      description: t("updateSuccess"),
      duration: 2,
    });
  };

  const onFinishFailedUpdate = () => setLoading(false);

  return (
    <div>
      <Form
        {...layout}
        name="basic"
        form={form}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinishUpdate}
        onFinishFailed={onFinishFailedUpdate}
      >
        <Row>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>

          <Col span={24}>
            <Form.Item
              style={{ marginTop: "4%" }}
              name="name"
              label={t("bankAccountName")}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="isCalculated"
              label={t("includeInCalculation")}
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
          </Col>

          {
            props.isAdmin == true && hasErp ?  <Col span={24}>
              <Form.Item
                name="excludeFromErpTransfer"
                label={t("excludeFromErpTransfer")}
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </Col> : <></>
          }

          <Col span={24}>
            <Form.Item label={t("bankAccountType")} name="typeValue">
              <Select
                style={{ width: "100%" }}
                placeholder={t("selectType")}
                onChange={(value) => setActiveTypeId(value)}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
              >
                <Option key="0">{t("termless")}</Option>
                <Option key="1">{t("credit")}</Option>
                <Option key="2">{t("term")}</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label={t("firmCode")} name="erpCode">
              <Input />
            </Form.Item>
          </Col>

          {IsChequePaymentAccount &&
            <>
              <Col span={24}>
                <Form.Item label={t("chequeCollectionAccountingCode")} name="chequeInPaymentAccount">
                  <Input />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item label={t("chequePaymentAccountingCode")} name="chequeOutPaymentAccount">
                  <Input />
                </Form.Item>
              </Col>
            </>
          }

          {(props.data.isManualAccount === true &&
            props.data.type === "Vadeli" &&
            activeTypeId === 0) ||
            (props.data.isManualAccount === true &&
              activeTypeId === "2" &&
              activeTypeId !== 0) ? (
            <>
              <Col span={24}>
                <Form.Item label={t("dueDate")} name="dueDate">
                  <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label={t("interestRate")} name="interestRate">
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    max={100}
                    decimalSeparator=","
                    precision={2}
                  />
                </Form.Item>
              </Col>
            </>
          ) : null}

          <Col span={24}>
            <Form.Item label={t("erpAccountingCode")} name="erpAccountingCode">
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label={t("erpBankCode")} name="erpBankCode">
              <Input />
            </Form.Item>
          </Col>

          <Col span={24} hidden={!props.data.isHasManualEnterCreditLimit}>
            <Form.Item
              label={
                <span>
                  {t("mainCreditLimit")}{" "}
                  <Tooltip title={t("mainCreditLimitTooltip")}>
                    <QuestionCircleOutlined
                      className="gx-text-blue"
                      style={{
                        marginRight: 10,
                        marginTop: 6,
                        fontSize: "150%",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="creditLimit"
            >
              <CurrencyInput
                className="ant-input"
                style={{ width: "100%" }}
                decimalSeparator=","
                thousandSeparator="."
                onChange={(value, name) => {
                  form.setFieldsValue({
                    creditLimit: name,
                  });
                }}
              />
            </Form.Item>
          </Col>

          <Col span={6}></Col>
          <Col span={6}></Col>
          <Col span={6}></Col>
          <Col span={6}>
            <Form.Item {...tailLayout}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                {t("update")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default TenantAccountUpdateForm;
